<template>
  <el-dialog
    :visible.sync="isBookingRoomDialogOpened"
    title="Thông tin đặt phòng"
    width="80%"
    append-to-body
    :close-on-click-modal="false"
    @close="() => {}"
  >
    <BookingRoomForm
      v-if="isBookingRoomDialogOpened"
      ref="BookingRoomForm"
      :action="'edit'"
      :record-data="bookingRoomFormData"
    ></BookingRoomForm>
    <span
      slot="footer"
      class="dialog-footer"
      style="display: flex; gap: 10px; justify-content: flex-end"
    >
      <!-- <button
        v-if="bookingRoomFormAction == 'create'"
        class="btn primary small"
        @click="onCreateBookingRoom"
      >
        Thêm
      </button> -->
      <button class="btn primary small" @click="onUpdateBookingRoom">
        Cập nhật
      </button>
      <!-- <button class="btn pink small outline" @click="onDeleteBookingRoom">
        Xóa
      </button> -->
      <button
        class="btn primary small outline"
        @click="isBookingRoomDialogOpened = false"
      >
        Đóng
      </button>
    </span>
  </el-dialog>
</template>

<script>
import BookingRoomForm from '@/components/resources/booking/BookingRoomForm.vue'

import {
  getBookingRoom,
  updateBookingRoom
} from '@/api/booking_service/booking'
import { notifyError, notifySuccess } from '@/utils/toast'

export default {
  components: {
    BookingRoomForm
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      bookingRoomFormData: null
    }
  },

  computed: {
    isBookingRoomDialogOpened: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  watch: {
    data(nv, ov) {
      if (nv) {
        this.fnGetBookingRoom(nv?.sub_booking_group_id)
      }
    }
  },

  methods: {
    async onUpdateBookingRoom() {
      const payload = this.$refs.BookingRoomForm.dehydrateForm()

      if (this.bookingRoomFormData.id) {
        await this.updateBookingRoom(this.bookingRoomFormData.id, payload)
        this.$emit('refresh')
        this.isBookingRoomDialogOpened = false
      }
    },

    onDeleteBookingRoom() {
      // this.formData.booking_room.splice(this.bookingRoomTableIndex, 1)
      // this.isBookingRoomDialogOpened = false
    },

    // handle api call
    fnGetBookingRoom(id) {
      if (id) {
        getBookingRoom(id)
          .then(res => {
            this.bookingRoomFormData = res.data
            this.isBookingRoomDialogOpened = true
          })
          .catch(() => {
            this.isBookingRoomDialogOpened = false
            this.$message({
              type: 'error',
              message: 'Đã có lỗi xảy ra'
            })
          })
          .finally(() => {})
      }
    },

    async updateBookingRoom(id, payload) {
      await updateBookingRoom(id, payload)
        .then(res => {
          notifySuccess(res?.message)
          return true
        })
        .catch(err => {
          notifyError(err?.response?.data?.message)
          return false
        })
    }
  }
}
</script>
